<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto;">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px">
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">应用服务日志详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <zj-layout-main>
        <el-form ref="form" :model="data" :rules="rules" label-width="16rem" style="width: 80%;">
          <el-row>
            <el-col :span="12">
              <el-form-item label="创建时间" prop="createTime">
                <el-date-picker
                  type="datetime"
                  style="width: 100%;"
                  placeholder="选择日期"
                  v-model="data.createTime"
                  v-bind:disabled="true"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="IP" prop="serverIp">
                <el-input v-model="data.serverIp" disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="事件" prop="event">
                <el-input v-model="data.event" disabled="true" type="textarea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="详情" prop="details">
                <el-input v-model="data.details" disabled="true" type="textarea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width:134rem;">
        <el-button @click="onBack()">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";

export default {
  name: "AppServerLogDetail",
  controller: "UI",
  action: "AppServerLogDetail",
  data() {
    return {
      data: {}
    };
  },
  created: function() {
    if (this.$route.query.InfoId) {
      this.search();
    }
  },
  mounted: function() {},
  watch: {
    $route: function() {
      if (this.$route.query.InfoId) {
        this.search();
      }
    }
  },
  methods: {
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        MyApis.AppServerLogApi.getAppServerLog(InfoId)
          .then(r => {
            this.data = r.data || r;
          })
          .catch(e => {
            console.log(e);
            this.errmsg(e && e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    }
  }
};
</script>
